export default __webpack_public_path__ + "static/media/Circle.81d60b74.svg";